import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';

const AgGridWrapper = (props: any) => {

    const defaultColDef = {
        filter: "agTextColumnFilter",
        sortable: true,
        resizable: true,
        filterParams: {
            newRowsAction: 'keep'
        }
    }

    return <div className="ag-theme-material" style={{ height: '600px', width: '100%' }}>
        <AgGridReact
            {...props.gridConfig}
            rowData={(props.rowData) ? props.rowData : null}
            defaultColDef={(props.defaultColDef) ? props.defaultColDef : defaultColDef}
            columnDefs={(props.columnDefs) ? props.columnDefs : null}
        >
        </AgGridReact>
    </div>
}

export default AgGridWrapper;
